import React from "react";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import AppButton from "../appButton/appButton";
import AppIcon from "../appIcon/appIcon";
import { downArrow } from "../icons";

import './appMultiActionButton.scss';

interface IAppMultiActionButton {
  actions: {
    label: string;
    onClick: () => void;
  }[];
  disabled?: boolean;
  containerId: string;
}

const AppMultiActionButton = ({
  actions,
  disabled,
  containerId
}: IAppMultiActionButton) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onPrimaryActionClick = () => {
    if (actions.length > 0) {
      actions[0].onClick();
    }
  }

  const onSecondaryActionClick = (action) => {
    action.onClick();
    handleClose();
  }

  const secondaryActions = actions.slice(1);
  const containerWidth = document.getElementById(containerId)?.offsetWidth;
  const containerHeight = (document.getElementById(containerId)?.offsetHeight || 38) + 1 + 'px';

  return (
    <div className="app-multi-action-button" id={containerId}>
      <AppButton onClick={onPrimaryActionClick} disabled={disabled} id="primary-action-btn" className="primary-btn-with-icon"> {actions[0]?.label} </AppButton>
      <AppButton onClick={handleClick} disabled={disabled} id="optios-btn" className="action-icon-btn"> <AppIcon icon={downArrow} /></AppButton>
      <Menu
        id="actions-menu-btn"
        disableEnforceFocus
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={1}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          sx: {
            backgroundColor: '#2e2e38',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
            color: '#fff',
            marginTop: containerHeight,
            minWidth: 100,
            width: containerWidth ? containerWidth : 'auto',
          },
        }}
      >
        {secondaryActions.map((action, key) => (
          <MenuItem
            key={key}
            sx={{
              paddingTop: 0,
              paddingBottom: 0,
              justifyContent: 'center',
              fontSize: 14,
            }}
            onClick={() => onSecondaryActionClick(action)}>
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default AppMultiActionButton;    